<template>
    <!-- <div class="hdr hdr__main">
        <slot></slot>
    </div> -->
        <div class="section__header">
        <slot></slot>
    </div>
</template>

<script>    
    export default {}
</script>

<style scoped lang="scss">
    @import '../../../scss/layouts/header.scss';
</style>